<template>
  <PersonnelVerify/>
</template>
<script>
import PersonnelVerify from 'place/personnelverify/personnelVerify.vue'
export default {
    components:{
      PersonnelVerify
    }
}
</script>